(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementTypeIbqDetailController', MusicalArrangementTypeIbqDetailController);

    MusicalArrangementTypeIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MusicalArrangementType'];

    function MusicalArrangementTypeIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, MusicalArrangementType) {
        var vm = this;

        vm.musicalArrangementType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:musicalArrangementTypeUpdate', function(event, result) {
            vm.musicalArrangementType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
